import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'

const AnalyticsCardTextWithTooltip = ({ tag, tagClassName, children, tooltipText, dataId }) => {
  const TextComponent = tag

  return (
    <>
      <TextComponent data-tip data-for={dataId} className={tagClassName || ''}>
        {children}
      </TextComponent>
      <ReactTooltip
        place="top"
        effect="solid"
        id={dataId}
        multiline
        html
        className="analytics-tooltip"
      >
        {tooltipText}
      </ReactTooltip>
    </>
  )
}

AnalyticsCardTextWithTooltip.propTypes = {
  tag: PropTypes.string,
  tagClassName: PropTypes.string,
  children: PropTypes.object,
  tooltipText: PropTypes.string,
  dataId: PropTypes.string,
}

export default AnalyticsCardTextWithTooltip
